module.exports = __webpack_public_path__ + "static/media/CHei2-Bold-HKSCS.d2c20dba.svg";